export default __webpack_public_path__ + "static/media/sp.7349efe6.svg";